<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'trajectoryInfo'
}
</script>

<style>

</style>
